module.exports = __webpack_public_path__ + "media/PAG67-01.5be8bfe1.mp3";